/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps, Theme } from '@mui/material';

export const productDetailsTabsDescriptionSX: SxProps<Theme> = {
	maxWidth: '65ch',
	'& > h3, & > p, & ul': {
		margin:0
	}
};

export const productAttrRowSX: SxProps<Theme> = {
	display:'flex', 
	alignItems:'center'
}

export const productAttrLabelSX: SxProps<Theme> = {
	minWidth: globalBreak({mobile:200, desktop:300}),
	fontSize: globalBreak({mobile:13, desktop:15}),
	alignSelf: 'flex-start',
	padding:'5px 0'
}

export const showHideDescriptionSX:SxProps = {
	fontFamily: 'chaloops-medium',
	fontWeight:700,
	cursor:'pointer'
}